import React, { Fragment, useRef, useState } from 'react';
import MetadataView from './MetadataView';
import ActionMenu from './ActionMenu';

import {
  Table
} from 'reactstrap';


const MAX_VISIBLE_COLUMNS = 4;
const getNumberOfColumns = () => {
  const nColumns = Math.ceil(window.innerWidth/250);
  return (nColumns > MAX_VISIBLE_COLUMNS)? MAX_VISIBLE_COLUMNS : nColumns;
}

const Documentlist = ({ documents, showDocument, editDocument, sort, update, save, strings, remove, showVersion, documentTypes }) => {

  const metadataView = useRef();
  const getDocuments = () => documents == null ? [] : documents;

  const getKeys = () => {
    const docs = getDocuments();
    if (docs.length === 0) return [];
    const firstObject = docs[0];
    if (!firstObject || typeof firstObject !== 'object') return [];
    const entries = Object.entries(firstObject);
    const sorted = entries.sort((a, b) => {
      let retval = 0;
      if (a[1] && a[1].general && (!b[1] || !b[1].general)) retval = -1;
      else if (b[1] && b[1].general && (!a[1] || !a[1].general)) retval = 1;
      else if (a[1] && a[1].order && b[1] && b[1].order) retval = a[1].order - b[1].order
      return retval;
    });
    const keys = [];
    for (let i=0; i<sorted.length; i++) {
      if (sorted[i] && sorted[i][0] && !sorted[i][0].startsWith('_'))
        keys.push(sorted[i][0])
    }
    return keys;
  }

  const getHeader = () => {
    const nColumns = getNumberOfColumns();
    var keys = getKeys();
    const headers = keys.map((key, index) => {
      if (index < nColumns) 
        return <th onClick={e => handleHeaderClick(e, index)} key={key}>{key.toUpperCase()}</th>
      else
        return (null);
    });
    headers.push(<th key="actions" style={{width: '80px', textAlign: 'center'}}>{strings['Actions'] || 'Actions'}</th>);
    return headers;
  }

  const getRows = () => {
    const keys = getKeys();
    return getDocuments().map((row, index) => {
      return <RenderRow key={index} row={index} data={row} keys={keys} 
                        onShowActions={handleRowClick} 
                        onOpenDocument={handleOpenDocument}
                        updateDocument={updateDocument}
                        saveDocument={saveDocument}
                        deleteDocument={deleteDocument}
                        editDocument={editDocument}
                        showDocument={showDocument}
                        showVersion={showVersion}
                        strings={strings}
                        documentTypes={documentTypes} />
    })
  }

  const handleHeaderClick = (e, index) => {
    e.preventDefault();
    const column = getKeys()[index];
    sort(column);
  }

  const handleRowClick = (rowIndex) => {
    if (!documents || !documents[rowIndex]) return;
    const o = documents[rowIndex];
    const metadata = {};
    for (let property in o) {
      if (!o.hasOwnProperty(property)) continue;
      metadata[property] = o[property];
    }
    const audit = (o._audit != null && o._audit.value != null)? o._audit : [];
    if (metadataView.current) {
      metadataView.current.toggle(metadata, audit, strings);
    }
  }

  const handleOpenDocument = (rowIndex) => {
    if (!documents || !documents[rowIndex]) return;
    const o = documents[rowIndex];
    if (showDocument) {
      showDocument(o);
    }
  }

  const updateDocument = (metadata) => {
    console.log(metadata['_index']);
    update(metadata);
  }

  const saveDocument = (metadata, id) => {
    //console.log(metadata['_index']);
    save(metadata, id);
  } 

  const deleteDocument = (metadata) => {
    console.log(metadata['_index']);
    remove(metadata);
  }

  return (
    <Fragment>
      <div>
        <Table striped hover>
          <thead>
            <tr>{getHeader()}</tr>
          </thead>
          <tbody>
            {getRows()}
          </tbody>
        </Table>
      </div>
      <MetadataView ref={metadataView} strings={strings} showDocument={showDocument} 
                                       updateDocument={updateDocument} saveDocument={saveDocument} 
                                       deleteDocument={deleteDocument} editDocument={editDocument}
                                       documentTypes={documentTypes}/>
    </Fragment>
  );
}

const tdStyle = {
  whiteSpace: 'normal',
  wordWrap: 'break-word'
};

const iconStyle = {
  cursor: 'pointer',
  fontSize: '18px',
  margin: '0 8px',
  userSelect: 'none'
};

const RenderRow = React.memo((props) => {
  const [showMenu, setShowMenu] = useState(false);
  const nColumns = getNumberOfColumns();
  if (!props.data || !props.keys) return null;
  const isLocked = props.data['LockedBy'] != null && props.data['LockedBy'] && props.data['LockedBy'].value;
  const audit = (props.data._audit != null && props.data._audit.value != null) ? props.data._audit : [];
  
  const handleMenuClick = (e) => {
    e.stopPropagation();
    console.log('Menu clicked, current state:', showMenu, 'setting to:', !showMenu);
    setShowMenu(prev => {
      console.log('State update from', prev, 'to', !prev);
      return !prev;
    });
  };

  const handleCloseMenu = () => {
    setShowMenu(false);
  };

  const cells = props.keys.map((key, index) => {
    if (index < nColumns) {
      const value = props.data[key] != null && props.data[key] ? props.data[key].value : "";
      const isLastColumn = index === nColumns - 1;
      const displayValue = isLastColumn && isLocked ? `${String(value)} 🔒` : String(value);
      return <td key={key} style={tdStyle} onClick={e => props.onShowActions(props.row)}>{displayValue}</td>
    }
    else
      return (null);
  });

  cells.push(
    <td key="actions" style={{textAlign: 'center', whiteSpace: 'nowrap'}}>
      <span style={iconStyle} onClick={(e) => { e.stopPropagation(); props.onOpenDocument(props.row); }} title="Open document">👁️</span>
      <span style={{...iconStyle, position: 'relative', display: 'inline-block'}}>
        <span onClick={handleMenuClick} title="Actions">⚙️</span>
        {showMenu && (
          <div style={{position: 'absolute', right: 0, top: '100%', zIndex: 9999}}>
            <ActionMenu 
              metadata={props.data}
              audit={audit}
              strings={props.strings}
              updateDocument={props.updateDocument}
              saveDocument={props.saveDocument}
              deleteDocument={props.deleteDocument}
              editDocument={props.editDocument}
              showDocument={props.showDocument}
              showVersion={props.showVersion}
              documentTypes={props.documentTypes}
              directMenu={true}
              onClose={handleCloseMenu}
            />
          </div>
        )}
      </span>
    </td>
  );
  
  console.log('RenderRow rendering, showMenu:', showMenu);
  return <tr>{cells}</tr>;
});

export default Documentlist;